import Vue from 'vue';
import VueRouter, { NavigationGuardNext } from 'vue-router';
import Propose from '@/views/Propose.vue';
import Login from '@/views/Login.vue';
import Trades from '@/views/Trades.vue';
import Accept from '@/views/Accept.vue';
import Info from '@/views/Info.vue';
import Tips from '@/views/Tips.vue';
import { Module1Module } from '@/store/modules/module1';
import { TezosFA2TraderAnonAddress } from '@/lib/constants';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/propose',
    name: 'Propose',
    component: Propose
  },
  {
    path: '/accept',
    name: 'Accept',
    component: Accept
  },
  {
    path: '/Trades',
    name: 'Trades',
    component: Trades
  },
  {
    path: '/Tips',
    name: 'Tips',
    component: Tips
  },
  {
    path: '/info',
    name: 'Info',
    component: Info
  },
  {
    path: '/contract',
    beforeEnter () {
      window.location.href = `https://tzkt.io/${TezosFA2TraderAnonAddress}`;
    }
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

/**
 * Route Navigation Guards
 */
export const beforeEachHandler = async (to: { path: string }, from: unknown, next: NavigationGuardNext<Vue>) : Promise<void> => {
  const loggedIn = !!Module1Module.account;

  if (loggedIn) {
    // /login and / redirect to /propose for logged-in users
    if (to.path === '/login' || to.path === '/') {
      return next('/propose');
    }

    return next();
  } else {
    if (to.path === '/') {
      return next('/propose');
    }

    if (
      to.path.includes('/accept') ||
      to.path.includes('/tips') ||
      to.path.includes('/info') ||
      to.path.includes('/login') ||
      to.path.includes('/propose')
    ) {
      return next();
    } else {
      // force all other paths to go to /login for logged-out users
      return next('/login');
    }
  }
};

router.beforeEach(beforeEachHandler);

export default router;
